export default [
  {
    displayText: 'Any',
    value: '',
  },
  {
    displayText: '1+',
    value: 1,
  },
  {
    displayText: '2+',
    value: 2,
  },
  {
    displayText: '3+',
    value: 3,
  },
  {
    displayText: '4+',
    value: 4,
  },
  {
    displayText: '5+',
    value: 5,
  },
  {
    displayText: '6+',
    value: 6,
  },
  {
    displayText: '7+',
    value: 7,
  },
  {
    displayText: '8+',
    value: 8,
  },
  {
    displayText: '9+',
    value: 9,
  },
  {
    displayText: '10+',
    value: 10,
  },
  {
    displayText: '25+',
    value: 25,
  },
  {
    displayText: '50+',
    value: 50,
  },
  {
    displayText: '100+',
    value: 100,
  },
  {
    displayText: '250+',
    value: 250,
  },
  {
    displayText: '500+',
    value: 500,
  },
  {
    displayText: '1,000+',
    value: 1000,
  },
];
